<div class="external-garage-assessment fx-col h-100">
  <div class="header d-flex align-center">
  </div>
  <div class="content fx-1">
    <div class="otp-verification-container h-100 d-flex align-center justify-center">
      <div class="otp-verify fx-col">
        @if (!isLinkExpired) {
          <div class="title-container fx-col gap-10">
            <div class="title">{{'verify_your_identity' | translate}}</div>
            <div class="sub-title">{{'enter_the_otp_sent_to' | translate}}</div>
          </div>
          <div class="separator"></div>
          <div class="otp-input-container">
            <ng-otp-input #ngOtpInput
              (onInputChange)="onOtpChange($event)"
            [config]="otpConfig"></ng-otp-input>
            @if (errorMessages) {
              <div
                class="wrong_otp">
                {{errorMessages}}
              </div>
            }
          </div>
          <div class="button-container">
            <xa-button class="verify-button"
              (click)="verifyOtp()"
            (keyPress)="verifyOtp()">{{'verify_and_continue' | translate}}</xa-button>
          </div>
          <div class="resend-otp-container">
            <div class="resend-otp pointer"
              (click)="sendOtp()"
            (keyPress)="sendOtp()">{{'resend_otp' | translate}}</div>
          </div>
        } @else {
          <div class="title-container fx-col gap-10">
            <div class="title">{{'sorry' | translate}}</div>
            <div class="sub-title">{{'link_expired' | translate}}</div>
          </div>
        }


      </div>
    </div>
  </div>
</div>